import styled from 'styled-components';
import { Label } from '../TCInputField/styles';
export const MainContainer = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    border-radius: 4px;
    height: 32px;
`;

export interface LabelContainerProps {
    readonly?: boolean
}
export const LabelContainer = styled.div`
    display:flex;
    flex:1;
    background-color: #FFF;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);    
    height: 40px;
    border-radius: 4px;
    text-align: center;

    &:hover {
        cursor: ${(props: LabelContainerProps) => props.readonly ? 'not-allowed' : 'pointer'};
    }
`
export interface InputContainerProps {
    height?: string
}

export const InputContainer = styled(LabelContainer)`
    background: white;
    height: ${(props: InputContainerProps) => props.height ? props.height : `32px`};
    flex:unset;
    align-items: center;
    padding: 0px;
    border-radius: 4px;
`
export const InputIcon = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 14px;
    position: relative;
    margin-right: 16px;
`

export const SuggestLabel = styled(Label)`
    display:flex;
    align-items: center;
    position: relative;
    height: inherit;
    font-family: 'Roboto';
    font-size: 14px;
    letter-spacing: normal;
    flex:1;
    justify-content: flex-start;
    padding: 10px 12px;
    color: #373f53;
    border-radius: 4px;
    box-sizing: border-box;
`

export const InputSuggestable = styled.input`
    display:flex;
    height: inherit;
    outline: none;
    width:70px;
    padding: none;
    border: none;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    flex:1;
    color: #373f53;
    background: transparent;
    padding: 10px 12px;
    box-sizing: border-box;
    &:hover {
        cursor:pointer;
    };
    &:focus {
        cursor: text;
    }
`

export const DrawerContainer = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    right:0px;

    z-index: 400;
    display: flex;
    flex-flow: column;
    max-height: 320px;
    background: transparent;

    border-radius: 4px;
    margin-bottom: 8px;
`

export const DrawerOptionsContainer = styled.div`
    position: relative;
    top: 4px;
    max-height: 280px;

    border-radius: 4px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);

    background: white;
    display:flex;
    flex:1;
    overflow: auto;
`

export const DrawerList = styled.ul`
    
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: column;
    flex:1;
    overflow: auto;
`
export interface DrawerListItemProps {
    highlighted: boolean
}

export const DrawerListItem = styled.li`
    height: 32px;
    display:flex;
    padding:8px;
    align-items: center;
    &:hover {
        cursor: pointer;
    };
    background: ${(props: DrawerListItemProps) => props.highlighted ? '#DADADA' : 'none'};
`
export const DrawerItemLabel = styled(Label)`
    font-family: Roboto;
    font-size: 14px;
    overflow:hidden;
    white-space:nowrap;
    color: #373f53;
    margin: 0 8px 0 8px;
`

export const DrawerEmptyState = styled(Label)`
    display:flex;
    font-family: Roboto;
    font-size: 14px;
    color: #373f53;
    padding: 16px;
    margin: 0 8px 0 8px;
    justify-content: center;
    align-items: center;
`

export const LoadMoreTarget = styled.div`
    display:flex;
    height: 40px;
    align-items:center;
    justify-content: center;
`